// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function getOpenOrderVM(param) {
  return {
          dry_run_distance: "N/A",
          dry_run_duration: "N/A",
          accepted_location: "N/A",
          start_location: "N/A",
          driver_location_accuracy: "Bad",
          trip_ended_location: "N/A",
          cancellation_source: "N/A",
          cancellation_reschedule_reason: "N/A"
        };
}

function getAcceptedOrderVm(accepted_order) {
  return {
          dry_run_distance: "N/A",
          dry_run_duration: "N/A",
          accepted_location: Belt_Option.mapWithDefault(accepted_order.accepted_location, "N/A", (function (l) {
                  return "Lat: " + (l.lat.toString() + (" Long: " + l.long.toString()));
                })),
          start_location: "N/A",
          driver_location_accuracy: Belt_Option.mapWithDefault(accepted_order.driver_location_accuracy, "Bad", (function (a) {
                  if (a < 50.0) {
                    return "Good";
                  } else {
                    return "Bad";
                  }
                })),
          trip_ended_location: "N/A",
          cancellation_source: "N/A",
          cancellation_reschedule_reason: "N/A"
        };
}

function getLiveOrderVm(accepted_order, started_order) {
  var init = getAcceptedOrderVm(accepted_order);
  return {
          dry_run_distance: init.dry_run_distance,
          dry_run_duration: init.dry_run_duration,
          accepted_location: init.accepted_location,
          start_location: Belt_Option.getWithDefault(started_order.start_location, "N/A"),
          driver_location_accuracy: init.driver_location_accuracy,
          trip_ended_location: init.trip_ended_location,
          cancellation_source: init.cancellation_source,
          cancellation_reschedule_reason: init.cancellation_reschedule_reason
        };
}

function getCancelledOrderVm(cancelled_order) {
  return {
          dry_run_distance: "N/A",
          dry_run_duration: "N/A",
          accepted_location: "N/A",
          start_location: "N/A",
          driver_location_accuracy: "Bad",
          trip_ended_location: "N/A",
          cancellation_source: cancelled_order.cancellation_source,
          cancellation_reschedule_reason: cancelled_order.cancellation_reason
        };
}

function getCancelledAcceptedOrderVm(cancelled_order, accepted_order) {
  var init = getAcceptedOrderVm(accepted_order);
  return {
          dry_run_distance: init.dry_run_distance,
          dry_run_duration: init.dry_run_duration,
          accepted_location: init.accepted_location,
          start_location: init.start_location,
          driver_location_accuracy: init.driver_location_accuracy,
          trip_ended_location: init.trip_ended_location,
          cancellation_source: cancelled_order.cancellation_source,
          cancellation_reschedule_reason: cancelled_order.cancellation_reason
        };
}

function getCancelledLiveOrderVm(cancelled_order, accepted_order, live_order) {
  var init = getLiveOrderVm(accepted_order, live_order);
  return {
          dry_run_distance: init.dry_run_distance,
          dry_run_duration: init.dry_run_duration,
          accepted_location: init.accepted_location,
          start_location: init.start_location,
          driver_location_accuracy: init.driver_location_accuracy,
          trip_ended_location: init.trip_ended_location,
          cancellation_source: cancelled_order.cancellation_source,
          cancellation_reschedule_reason: cancelled_order.cancellation_reason
        };
}

function getEndedOrderVm(accepted_order, started_order, ended_order) {
  var init = getLiveOrderVm(accepted_order, started_order);
  return {
          dry_run_distance: ended_order.dry_run_distance.toString(),
          dry_run_duration: Belt_Option.mapWithDefault(ended_order.dry_run_duration, "N/A", (function (v) {
                  return v.toString() + " mins";
                })),
          accepted_location: init.accepted_location,
          start_location: init.start_location,
          driver_location_accuracy: init.driver_location_accuracy,
          trip_ended_location: Belt_Option.getWithDefault(ended_order.trip_ended_location, "N/A"),
          cancellation_source: init.cancellation_source,
          cancellation_reschedule_reason: init.cancellation_reschedule_reason
        };
}

function getCancelledCompletedOrderVm(started_order, accepted_order, cancelled_order, ended_order) {
  var init = getCancelledOrderVm(cancelled_order);
  return {
          dry_run_distance: ended_order.dry_run_distance.toString(),
          dry_run_duration: Belt_Option.mapWithDefault(ended_order.dry_run_duration, "N/A", (function (v) {
                  return v.toString() + " mins";
                })),
          accepted_location: Belt_Option.mapWithDefault(accepted_order.accepted_location, "N/A", (function (l) {
                  return "Lat: " + (l.lat.toString() + (" Long: " + l.long.toString()));
                })),
          start_location: Belt_Option.getWithDefault(started_order.start_location, "N/A"),
          driver_location_accuracy: Belt_Option.mapWithDefault(accepted_order.driver_location_accuracy, "Bad", (function (a) {
                  if (a < 50.0) {
                    return "Good";
                  } else {
                    return "Bad";
                  }
                })),
          trip_ended_location: Belt_Option.getWithDefault(ended_order.trip_ended_location, "N/A"),
          cancellation_source: init.cancellation_source,
          cancellation_reschedule_reason: init.cancellation_reschedule_reason
        };
}

function getVm(order) {
  switch (order.TAG | 0) {
    case /* Open */0 :
        return {
                dry_run_distance: "N/A",
                dry_run_duration: "N/A",
                accepted_location: "N/A",
                start_location: "N/A",
                driver_location_accuracy: "Bad",
                trip_ended_location: "N/A",
                cancellation_source: "N/A",
                cancellation_reschedule_reason: "N/A"
              };
    case /* Accepted */1 :
        return getAcceptedOrderVm(order._1);
    case /* Live */2 :
        return getLiveOrderVm(order._1, order._2);
    case /* Ended */3 :
        return getEndedOrderVm(order._1, order._2, order._3);
    case /* Cancelled */4 :
        return getCancelledOrderVm(order._1);
    case /* CancelledAccepted */5 :
        return getCancelledAcceptedOrderVm(order._1, order._2);
    case /* CancelledLive */6 :
        return getCancelledLiveOrderVm(order._1, order._2, order._3);
    case /* CancelledCompleted */7 :
    case /* CancelledEnded */8 :
        break;
    
  }
  return getCancelledCompletedOrderVm(order._1, order._2, order._3, order._4);
}

export {
  getOpenOrderVM ,
  getAcceptedOrderVm ,
  getLiveOrderVm ,
  getCancelledOrderVm ,
  getCancelledAcceptedOrderVm ,
  getCancelledLiveOrderVm ,
  getEndedOrderVm ,
  getCancelledCompletedOrderVm ,
  getVm ,
  
}
/* No side effect */
